import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import CountrySwitcher from '../../containers/Commons/CountrySwitcher/CountrySwitcher';
import logo from './darkova-krabicka-logo-pink.svg';
import cartIcon from './cart-icon.svg';
import InlineSVG from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';

export default class Header extends Component {
    render() {
        return (
            <nav className="header">
                <div className="container ">
                    <div className="header-upper">
                        <Link to="/" className="logo">
                            <img src={logo} width={250} height={20} alt="Dárková krabička logo" />
                        </Link>
                        <div className="header-upper-right">
                            <div className="country-switcher-wrapper">
                                <CountrySwitcher hasIcon={true} />
                            </div>
                            <Link to="/kosik">
                                <span
                                    className={
                                        this.props.cartItems > 0
                                            ? 'header-cart  badge'
                                            : 'header-cart'
                                    }
                                    data-badge={this.props.cartItems}
                                >
                                    <InlineSVG src={cartIcon} />
                                </span>
                            </Link>
                        </div>
                    </div>

                    <div className="nav">
                        <ul>
                            <li>
                                <Link to="/konfigurator" activeClassName="active">
                                    <FormattedMessage
                                        defaultMessage="Sestavte krabičku"
                                        id={'global.configurator'}
                                    />
                                </Link>
                            </li>
                            <li>
                                <Link to="/hotove-balicky" activeClassName="active">
                                    <FormattedMessage
                                        defaultMessage="Hotové balíčky"
                                        id={'global.packages'}
                                    />
                                </Link>
                            </li>
                            <li>
                                <Link to="/produkty" activeClassName="active">
                                    <FormattedMessage
                                        defaultMessage="Samostatné produkty"
                                        id={'global.productsLong'}
                                    />
                                </Link>
                            </li>

                            <li>
                                <Link to="/inspirace" activeClassName="active">
                                    <FormattedMessage
                                        defaultMessage="Inspirace"
                                        id={'global.inspiration'}
                                    />
                                </Link>
                            </li>
                            <li>
                                <span className="nav-separator" />
                            </li>
                            <li>
                                <Link to="/firemni-darky" activeClassName="active">
                                    <FormattedMessage
                                        defaultMessage="Firemní dárky"
                                        id={'global.corporateGifs'}
                                    />
                                </Link>
                            </li>
                            <li>
                                <Link to="/svatebni-balicky" activeClassName="active">
                                    <FormattedMessage
                                        defaultMessage="Krabičky na svatbu"
                                        id={'global.weddingGifts'}
                                    />
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

Header.defaultProps = { cartItems: 1 };

Header.propTypes = {
    cartItems: PropTypes.number
};
